import React, { useCallback, useState, useEffect } from 'react'
// import { Dialog, Popover, Tab, Transition, Menu } from '@headlessui/react'
import ProductNav from './../pages/productNav'
import ProductDialog from './productdialog'
import ShoppingCard from './shippingcard'
import { useSelector, useDispatch } from 'react-redux';
import { getGroceryProducts, AddtoGROCERYList, getProductsforDecore } from './../Redux/action'
import { Helmet } from 'react-helmet-async';
import {
    useParams, useNavigate
} from "react-router-dom";
// import { XMarkIcon, MagnifyingGlassIcon } from '@heroicons/react/20/solid'
import axios from 'axios';
import Discount from './../assist/Discount.png';
import { Fragment } from 'react'
// import { ChevronDownIcon } from '@heroicons/react/20/solid'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

import Logo from './../assist/triokzzlohgo.svg';
import Loadinglogo from './../assist/loadinglogo.png';
import OfferImg from '../assist/offeroffer.jpg';
import Hnadcrafted from '../assist/handicrafted_item.jpg';
import BackgroundFrame from '../assist/backgroundframe.jpg';
import Bagimg from '../assist/bag.jpg';
import PrintedMug from '../assist/PrintedMug.png';
import firebase from 'firebase/compat/app';
import "firebase/compat/messaging";
import { getMessaging, getToken } from "firebase/messaging";
import { analytics, messaging } from './../Notification/firebase.js'
import { onMessage } from 'firebase/messaging';
import toast, { Toaster } from 'react-hot-toast';
import GoogleReviews from "./../about/googleReview.js";
// import addNotification from 'react-push-notification';

// import Chatbot from './chatbot'
import FirstAd from '../assist/ad1.png';
import SecondAd from '../assist/ad2.png';
import ThirdAd from '../assist/ad3.png';
import ForthAd from '../assist/ad4.jpg';
import review1 from '../assist/review1.png';
import review2 from '../assist/review2.png';
import review3 from '../assist/review3.png';
import review4 from '../assist/review4.png';
import review5 from '../assist/review5.png';
import review6 from '../assist/review6.png';
import review7 from '../assist/review7.png';
import OfferBanner from '../assist/OfferBanner.jpg';
// import './Celebration.css'
import OfferCard from './../pages/offer.js';
import OptimizedImage from './../about/optimizedImages.js';

const Advertise = [

    { id: 0, imgSrc: "https://shopnowindia.s3.ap-south-1.amazonaws.com/organic_product/Triorg.png" },
    { id: 1, imgSrc: "https://shopnowindia.s3.ap-south-1.amazonaws.com/organic_product/Triorg.png" },
    { id: 2, imgSrc: "https://shopnowindia.s3.ap-south-1.amazonaws.com/organic_product/Triorg.png" },
    { id: 3, imgSrc: "https://shopnowindia.s3.ap-south-1.amazonaws.com/organic_product/Triorg.png" },
    { id: 4, imgSrc: Hnadcrafted },
    { id: 5, imgSrc: review5 },
    // { id: 6, imgSrc: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cb/Clothing_store_banner.JPG/1920px-Clothing_store_banner.JPG" },
    { id: 7, imgSrc: "https://shopnowindia.s3.ap-south-1.amazonaws.com/organic_product/Triorg.png" },
    { id: 8, imgSrc: "https://shopnowindia.s3.ap-south-1.amazonaws.com/organic_product/Triorg.png" },
    { id: 9, imgSrc: "https://shopnowindia.s3.ap-south-1.amazonaws.com/organic_product/Triorg.png" },
    { id: 10, imgSrc: "https://shopnowindia.s3.ap-south-1.amazonaws.com/organic_product/Triorg.png" },
    { id: 11, imgSrc: "https://shopnowindia.s3.ap-south-1.amazonaws.com/organic_product/Triorg.png" },
]

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}
const GroceryList = (props) => {
    const { main, subproduct } = useParams()
    const [subNavItem, setSubNavItem] = useState(subproduct)
    const [dialog, setDialog] = useState(false)
    const [cardProduct, setCardProduct] = useState({})
    const [addtocard, setAddtocard] = useState([])
    const [openshopping, setOpenShopping] = useState(false)
    const [navItem, setNavItem] = useState(main)
    const [serchableoutput, setserchableoutput] = useState([])
    const [confirmModal, setConfirmModal] = useState(false)
    const [menuproduct, setMenuProduct] = useState([])
      const [showChild, setShowChild] = useState(false);
    const navigate = useNavigate()
    const dispatch = useDispatch()
    // let siginUserInfo = JSON.parse(localStorage.getItem('signiniNFO'))
    const [siginUserInfo, setSigninUserInfo] = useState(null);

useEffect(() => {
  const stored = localStorage.getItem('signiniNFO');
  if (stored) {
    setSigninUserInfo(JSON.parse(stored));
  }
}, []);

    const getProducts = async (navItem) => {

        let TrendingProducts = await axios.get("https://kqej90wmli.execute-api.ap-south-1.amazonaws.com/dev/organic_products")
            .then(r => r)
            .then(res => res.data)
            .catch(err => console.log(err))
        setMenuProduct(TrendingProducts)
    };
    useEffect(() => {
        getProducts("Millets")
    }, [])

    //  useEffect(() => {
    //         const timer = setTimeout(() => {
    //             setShowChild(true);
    //         }, 15000); // Show after 3 seconds
    //         //   return clearTimeout(timer); // Cleanup on unmount
    //     }, [])

    useEffect(()=>{

        const firstNames = [ 
            'Aarav', 'Aditi', 'Akshay', 'Amit', 'Ananya', 
            'Arjun', 'Avani', 'Bhavya', 'Chetan', 'Devi', 
            'Divya', 'Gaurav', 'Isha', 'Kiran', 'Manoj', 
            'Neha', 'Preeti', 'Rajesh', 'Riya', 'Shreya', 
            'Varun', 'Saurabh', 'Ajay', 'Sandip', 'Sadan', 
            'Jyoti', 'Sapna', 'Prem'
        ]; 
        const lastNames = [ 
            'Agarwal', 'Bansal', 'Pundalikar', 'Gupta', 'Jain', 
            'Kapoor', 'Mehta', 'Patel', 'Rao', 'Sharma', 
            'Khadke', 'Kolhe', 'Chaudhari', 'Shah', 'Sonar', 
            'Singh', 'Trivedi', 'Verma', 'Yadav','Pardesi','Bhangale',
            'Attarde', 'Yeole', 'Mishra', 'Vasuki','Anantam','Karkota',
            'Adisheshamurti','Krishnamurti','Shriwastawa'
        ]; 

        const Catalog = [ 
            'kumkumadi oil', 'Banarasi sari', 'Gir ghee', 'Paithani saree', 'Printed Mug', 
            'Customize Batge', 'Rounded Purse'
        ]; 
    
        // To conjure up a name out of nowhere, use this function. 

        const interval =  setInterval(()=>{
            const randomFirstName = 
            firstNames[Math.floor(Math.random() * firstNames.length)]; 
        const randomLastName = 
            lastNames[Math.floor(Math.random() * lastNames.length)]; 
            const ProductsCatalog = 
            Catalog[Math.floor(Math.random() * Catalog.length)]; 
            toast(
                <span>
                <div className="flex p-2">
                <a href="https://www.facebook.com/profile.php?id=61553460826080&mibexid=ZbWKwL" role="button">
                            <span class="[&>svg]:h-7 [&>svg]:w-7 [&>svg]:fill-[#1877f2]">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
                                    <path
                                        d="M80 299.3V512H196V299.3h86.5l18-97.8H196V166.9c0-51.7 20.3-71.5 72.7-71.5c16.3 0 29.4 .4 37 1.2V7.9C291.4 4 256.4 0 236.2 0C129.3 0 80 50.5 80 159.4v42.1H14v97.8H80z" />
                                </svg>
                            </span>
                        </a>
    
                        <a href="https://www.instagram.com/triokzz?igsh=MWUzM3dweTNyY2NpeA==" role="button">
                            <span class="[&>svg]:h-7 [&>svg]:w-7 [&>svg]:fill-[#c13584]">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                                    <path
                                        d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z" />
                                </svg>
                            </span>
                        </a>
                    <div class="flex">
             <span class="text-xs text-gray-900 dark:text-gray">{randomFirstName} {randomLastName} Purchase {ProductsCatalog} </span>
     </div>
    
                    </div>
                </span>,
                {
                    icon: <div className="grid grid-cols-1">
                    <div className="flex md:w-auto h-12" tabIndex="0">
                        <a aria-label="Download on the Google Play Store"
                            className="rounded-2xl p-2 flex items-center w-40 sm:w-48 md:w-56 bg-white text-gray-900 hover:bg-gray-50"
                            href="https://play.google.com/store/apps/details?id=com.triokzz.app" target="_blank" rel="noopener noreferrer">
                            <svg width="100%" viewBox="0 0 132 43" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M107.104 31.6918H109.041V18.4767H107.104V31.6918ZM124.55 23.2375L122.33 28.9665H122.263L119.959 23.2375H117.873L121.329 31.2447L119.358 35.699H121.378L126.704 23.2378L124.55 23.2375ZM113.565 30.1908C112.932 30.1908 112.046 29.8674 112.046 29.0685C112.046 28.0485 113.149 27.6575 114.099 27.6575C114.951 27.6575 115.352 27.8442 115.869 28.0994C115.719 29.3236 114.684 30.1908 113.565 30.1908ZM113.799 22.9484C112.397 22.9484 110.945 23.5776 110.344 24.9717L112.063 25.7025C112.43 24.9717 113.114 24.7339 113.833 24.7339C114.834 24.7339 115.853 25.3454 115.869 26.4338V26.5696C115.518 26.3656 114.767 26.0597 113.849 26.0597C111.995 26.0597 110.109 27.0965 110.109 29.0346C110.109 30.8027 111.629 31.9419 113.331 31.9419C114.633 31.9419 115.352 31.3468 115.802 30.6495H115.869V31.6702H117.74V26.6034C117.74 24.2573 116.019 22.9484 113.799 22.9484ZM101.829 24.8461H99.0737V20.3166H101.829C103.277 20.3166 104.099 21.5372 104.099 22.5813C104.099 23.6054 103.277 24.8461 101.829 24.8461ZM101.779 18.477H97.1377V31.6922H99.0738V26.6857H101.779C103.926 26.6857 106.036 25.1035 106.036 22.5818C106.036 20.0606 103.926 18.477 101.779 18.477ZM76.4709 30.193C75.1328 30.193 74.0128 29.0517 74.0128 27.4856C74.0128 25.9012 75.1328 24.7438 76.4709 24.7438C77.792 24.7438 78.8288 25.9013 78.8288 27.4856C78.8288 29.0517 77.792 30.193 76.4709 30.193ZM78.695 23.9772H78.628C78.1934 23.4494 77.3568 22.9726 76.3038 22.9726C74.096 22.9726 72.0726 24.9483 72.0726 27.4856C72.0726 30.0056 74.096 31.9639 76.3038 31.9639C77.3568 31.9639 78.1933 31.487 78.628 30.9424H78.695V31.589C78.695 33.3096 77.792 34.2287 76.3371 34.2287C75.1502 34.2287 74.4143 33.3603 74.113 32.6282L72.4243 33.3433C72.9088 34.5349 74.1962 36 76.3372 36C78.6119 36 80.535 34.6373 80.535 31.3164V23.2449H78.695L78.695 23.9772ZM81.8731 31.6914H83.8121V18.4763H81.8731V31.6914ZM86.672 27.332C86.6221 25.5949 87.9938 24.7096 88.98 24.7096C89.7496 24.7096 90.4011 25.1014 90.6194 25.663L86.672 27.332ZM92.6921 25.8331C92.3244 24.829 91.204 22.9726 88.913 22.9726C86.6383 22.9726 84.7488 24.7947 84.7488 27.4683C84.7488 29.9887 86.6221 31.964 89.13 31.964C91.1534 31.964 92.3244 30.7042 92.8097 29.9717L91.3045 28.9498C90.8027 29.6992 90.1174 30.1931 89.13 30.1931C88.1439 30.1931 87.4412 29.7331 86.9904 28.8306L92.8928 26.3444L92.6921 25.8331ZM45.6614 24.352V26.2593H50.1431C50.0093 27.3321 49.6581 28.1153 49.1229 28.6603C48.4705 29.3243 47.4504 30.0568 45.6614 30.0568C42.902 30.0568 40.7449 27.792 40.7449 24.9822C40.7449 22.1723 42.902 19.9072 45.6614 19.9072C47.1498 19.9072 48.2365 20.5034 49.0393 21.2697L50.3608 19.9241C49.24 18.8344 47.7519 18 45.6614 18C41.8814 18 38.7041 21.1334 38.7041 24.9822C38.7041 28.8305 41.8814 31.964 45.6614 31.964C47.7013 31.964 49.2401 31.2827 50.4439 30.0056C51.6815 28.7454 52.0662 26.9745 52.0662 25.5438C52.0662 25.1015 52.0325 24.6928 51.9656 24.352H45.6614ZM57.162 30.193C55.8238 30.193 54.6699 29.069 54.6699 27.4683C54.6699 25.8505 55.8238 24.7439 57.162 24.7439C58.4996 24.7439 59.6536 25.8505 59.6536 27.4683C59.6536 29.069 58.4996 30.193 57.162 30.193ZM57.162 22.9726C54.7197 22.9726 52.73 24.8628 52.73 27.4683C52.73 30.0568 54.7197 31.964 57.162 31.964C59.6033 31.964 61.5934 30.0568 61.5934 27.4683C61.5934 24.8628 59.6033 22.9726 57.162 22.9726ZM66.8291 30.193C65.4919 30.193 64.3375 29.069 64.3375 27.4683C64.3375 25.8505 65.492 24.7439 66.8291 24.7439C68.1673 24.7439 69.3208 25.8505 69.3208 27.4683C69.3208 29.069 68.1673 30.193 66.8291 30.193ZM66.8291 22.9726C64.3878 22.9726 62.3981 24.8628 62.3981 27.4683C62.3981 30.0568 64.3878 31.964 66.8291 31.964C69.2714 31.964 71.2611 30.0568 71.2611 27.4683C71.2611 24.8628 69.2714 22.9726 66.8291 22.9726Z"
                                    fill="black"></path>
                                <path
                                    d="M17.1955 20.2345L6.10352 32.008C6.10393 32.0104 6.10477 32.0124 6.10516 32.0149C6.44534 33.2934 7.61306 34.2347 8.9989 34.2347C9.55289 34.2347 10.073 34.085 10.5191 33.822L10.5545 33.8013L23.0406 26.5962L17.1955 20.2345Z"
                                    fill="#EB3131"></path>
                                <path
                                    d="M28.4174 18.23L28.4068 18.2227L23.0161 15.0977L16.9429 20.5019L23.0372 26.5955L28.3994 23.5015C29.3395 22.994 29.9778 22.0029 29.9778 20.8601C29.9778 19.7254 29.3482 18.7392 28.4174 18.23Z"
                                    fill="#F6B60B"></path>
                                <path
                                    d="M6.10173 9.66211C6.03505 9.908 6 10.1656 6 10.433V31.2378C6 31.5048 6.03463 31.7632 6.10215 32.0082L17.5771 20.5356L6.10173 9.66211Z"
                                    fill="#5778C5"></path>
                                <path
                                    d="M17.2769 20.8353L23.0186 15.0954L10.5465 7.86427C10.0931 7.59274 9.56402 7.43604 8.99785 7.43604C7.61201 7.43604 6.44272 8.3791 6.10247 9.65905C6.10205 9.6603 6.10205 9.66116 6.10205 9.66225L17.2769 20.8353Z"
                                    fill="#3BAD49"></path>
                                <path
                                    d="M44.9244 10.2667H41.922V11.0704H44.1719C44.1107 11.7263 43.8695 12.2412 43.4626 12.6152C43.0558 12.9892 42.5363 13.177 41.922 13.177C41.2482 13.177 40.6773 12.9231 40.2094 12.4187C39.751 11.9038 39.5179 11.267 39.5179 10.4999C39.5179 9.73287 39.751 9.09613 40.2094 8.58127C40.6773 8.07684 41.2482 7.82457 41.922 7.82457C42.2678 7.82457 42.5975 7.88892 42.8997 8.02986C43.2021 8.17069 43.4449 8.3673 43.6347 8.61958L44.2056 8.00203C43.9467 7.68363 43.6186 7.44014 43.2117 7.26269C42.8048 7.08523 42.3803 7.00006 41.9219 7.00006C41.023 7.00006 40.2608 7.3375 39.6384 8.01074C39.0161 8.68562 38.7041 9.51716 38.7041 10.4999C38.7041 11.4827 39.0161 12.3161 39.6384 12.9893C40.2608 13.6624 41.023 14 41.9219 14C42.8659 14 43.6186 13.6729 44.1975 13.0084C44.7073 12.4553 44.9678 11.7073 44.9678 10.7714C44.9678 10.6131 44.9501 10.4442 44.9244 10.2667ZM46.0875 7.14951V13.8503H49.7042V13.0274H46.8836V10.9018H49.4277V10.0981H46.8836V7.97411H49.7042V7.14949L46.0875 7.14951ZM54.7755 7.97414V7.14951H50.5188V7.97414H52.2492V13.8503H53.0452V7.97414H54.7755ZM58.6294 7.14951H57.8334V13.8503H58.6294V7.14951ZM63.8836 7.97414V7.14951H59.6269V7.97414H61.3571V13.8503H62.1531V7.97414H63.8836ZM71.9162 8.02112C71.3019 7.33745 70.5493 7 69.6503 7C68.7498 7 67.9972 7.33744 67.3828 8.01068C66.7685 8.67521 66.4663 9.50841 66.4663 10.4999C66.4663 11.4914 66.7685 12.3247 67.3828 12.9893C67.9972 13.6624 68.7498 13.9999 69.6503 13.9999C70.5412 13.9999 71.3018 13.6624 71.9162 12.9893C72.5305 12.3247 72.8328 11.4914 72.8328 10.4999C72.8328 9.5171 72.5305 8.68552 71.9162 8.02112ZM67.9538 8.58122C68.4121 8.07678 68.9749 7.82451 69.6503 7.82451C70.3241 7.82451 70.887 8.07679 71.3372 8.58122C71.7956 9.07697 72.0206 9.72399 72.0206 10.4999C72.0206 11.2775 71.7956 11.9228 71.3372 12.4186C70.887 12.923 70.3241 13.177 69.6503 13.177C68.9749 13.177 68.412 12.923 67.9538 12.4186C67.505 11.9124 67.2799 11.2775 67.2799 10.4999C67.2799 9.72401 67.505 9.08739 67.9538 8.58122ZM74.724 9.67715L74.6903 8.38457H74.724L77.8727 13.8502H78.7041V7.14945H77.9081V11.0703L77.9418 12.3629H77.9081L74.8977 7.14945H73.928V13.8502H74.724V9.67715Z"
                                    fill="black" stroke="black" strokeWidth="0.26666" strokeMiterlimit="10"></path>
                            </svg>
                        </a>
                    </div>
                </div>,
                id:Math.floor(Math.random() ),
                position: 'bottom-center'
                },
                {
                    duration: 3000,
                }
            )
        },50000)
    
        return ()=> clearInterval(interval)
    },[])

    const onSelectNavItem = (item) => {
        if (item == "watchtv") {
            navigate(`/watchtv`)
        } else {
            setNavItem(item)
        }

        // navigate(`/${item}`)
    }


    // const handlePopstate = (event) => {
    //     // Your logic to handle the back button click
    //     // event.preventDefault();
    //     alert("are you sure")
    //     window.history.pushState({}, "", "grocery/products")
    //     window.history.pushState({}, "", "list/grocery/Millets")
    // };
    // useEffect(() => {
    //     window.addEventListener('popstate', handlePopstate)
    //     return window.removeEventListener('popstate', handlePopstate)
    // }, [window.location])


    // get data from redux
    let GroceryProducts = []
    GroceryProducts = useSelector(state => state.allProducts.grocery)

    // dispatch action 
    const scrolltobottom = () => {
        window.scrollTo(0, 700)
    }
    useEffect(() => {
        dispatch(getGroceryProducts(main))
        // scrolltobottom()
    }, [main, navItem])

    const onitemSelect = (items) => {
        navigate(`/list/grocery/${items}`)
        // return scrolltobottom()
    }

    const onshoppingRender = useCallback(() => {
        // navigate("product/shoppingCard")
        return setOpenShopping(true)
    }, [])

    const onOpen = (product, shopping_card_id) => {

        let somthing = addtocard && addtocard.find((val) => {
            // console.log(val)
            return val.id == product.id
        })
        if (!product.freez && somthing == undefined) {
            setDialog(!dialog)
            setCardProduct(product)
            console.log("render", shopping_card_id)
        } else {
            if (shopping_card_id >= 0) {
                const forSizechange = {
                    brand: product && product.name,
                    color: product && product.colors && product.colors.name,
                    count: 1,
                    detail_url: product && product.detail_url,
                    freez: false,
                    id: product && product.id,
                    offer_prize: product && product.price,
                    product_detail: product && product.detail,
                    product_name: product && product.product_name,
                    quantity: "10",
                    rating: product && product.rating,
                    real_prize: product && product.real_prize,
                    size: product && product.size,
                    type: product && product.type,
                    uni_productId: 1317,
                    url: product && product.imageSrc,
                    delivery_charge: product && product.delivery_charge,
                    navItem:product && product.navItem,
                    keywords:product && product.keywords
                }
                setCardProduct(forSizechange)
                setTimeout(() => {
                    setDialog(!dialog)
                })
            } else {
                onshoppingRender()
            }
        }
    }


    const onfilter = async (serchinput) => {
        // console.log("asasa")
        let searchableoutput = []
        let serching = serchinput && serchinput.toLowerCase() || subNavItem && subNavItem.toLowerCase()
        if (serching && serching.length > 2) {
            let TrendingProductsforsearch = await axios.get("https://kqej90wmli.execute-api.ap-south-1.amazonaws.com/dev/organic_products")
                .then(r => r)
                .then(res => res.data)
                .catch(err => console.log(err))


            let productaction = TrendingProductsforsearch && TrendingProductsforsearch.products && TrendingProductsforsearch.products.find((val, i, arr) => {
                return val.product_for == navItem
            })

            productaction.section.map((value, index) => {
                let [keys] = Object.keys(value)
                let arr = value[keys]
                let hello = arr.map(val => val)

                const filteredval = hello.filter(info => {

                    return info && info.product_detail && info.product_detail.toLowerCase() && info.product_detail.toLowerCase().includes(serching)
                }
                )
                console.log(filteredval)
                if (filteredval.length > 0) {
                    setserchableoutput(filteredval)
                }

                return filteredval
            })

        }

    }




    // added items
    const onAddToCard = (cardproducts) => {
        window.gtag('event', 'conversion', {
            send_to: 'AW-11415759693/5sa9CJmbsZEZEM3WusMq',
            value: cardproducts && cardproducts.price,       // replace with dynamic total
            currency: 'INR',
            transaction_id: cardproducts && cardproducts.id
        });
        window.gtag('event', 'conversion', {
            send_to: 'AW-11415759693/haFsCPXm5_cYEM3WusMq',
            value: cardproducts && cardproducts.price,       // replace with dynamic total
            currency: 'INR',
            transaction_id: cardproducts && cardproducts.id
        });

        if (typeof window.fbq === 'function' && window.fbq.loaded) {
            window.fbq('track', 'ViewContent', {
                content_ids: [cardproducts && cardproducts.id], // 'REQUIRED': array of product IDs
                content_type: 'product', // RECOMMENDED: Either product or product_group based on the content_ids or contents being passed.
            });
            window.fbq('track', 'AddToCart', {
                content_ids: [cardproducts && cardproducts.id], // 'REQUIRED': array of product IDs
                value: cardproducts && cardproducts.price + ".00", // REQUIRED, up to 2 decimals optional
                currency: 'INR',
                content_type: 'product', // RECOMMENDED: Either product or product_group based on the content_ids or contents being passed.
            });
        }
        
        let somthing = addtocard && addtocard.find((val) => {
            return val.id == cardproducts.id
        })

        if (somthing) {
            let filtereditem = addtocard && addtocard.filter((val) => {
                return val.id !== cardproducts.id
            })
            let items = filtereditem.concat(cardproducts)
            setAddtocard(items)
            localStorage.setItem("addtoGrocerycard", JSON.stringify(items))
            dispatch(AddtoGROCERYList(items))
            onshoppingRender()
        } else
            if (somthing == undefined) {
                let items = addtocard && addtocard.concat(cardproducts)
                setAddtocard(items)
                localStorage.setItem("addtoGrocerycard", JSON.stringify(items))
                dispatch(AddtoGROCERYList(items))
                onshoppingRender()
            } else {
                onshoppingRender()
            }
        analytics.logEvent('add_to_cart')
        const message = {
            notification: {
                title: '$FooCorp up 1.43% on the day',
                body: '$FooCorp gained 11.80 points to close at 835.67, up 1.43% on the day.'
            },
            webpush: {
                fcm_options: {
                    link: "https://triokzz.com"
                }
            }
        };
        toast(
            <span>
                <b>We saved your cart! Complete checkout now to avoid missing out.</b>
            </span>,
            {
                icon: '🔥',
            },
            {
                duration: 2000,
            }
        )
 
    }

    // qantity of the product
    const onCount = (e, id, index) => {
        var a = addtocard && addtocard.find((val, i) => val.id == id)
        // console.log(a.id, id)
        if (a.id == id) {
            addtocard[index].count = e.target.value
            localStorage.setItem("addtoGrocerycard", JSON.stringify(addtocard))
        }

    }

    const onRemove = (item, index) => {
        const removeItem = addtocard && addtocard.filter((value, i) => {
            return i !== index
        })
        setAddtocard(removeItem)
        localStorage.setItem("addtoGrocerycard", JSON.stringify(removeItem))
        dispatch(AddtoGROCERYList(removeItem))
    }

    useEffect(() => {

        const getitem = localStorage.getItem("addtoGrocerycard")
        if (getitem != null) {
            setAddtocard(JSON.parse(getitem))
            dispatch(AddtoGROCERYList(JSON.parse(getitem)))
        }

    }, [])
    useEffect(() => {
        setTimeout(() => {
            sessionStorage.setItem("addtoGrocerycard", JSON.stringify(addtocard))
        }, 100)

    }, [addtocard])


    return (
        <div className="bg-orange-50 justify-center">
            <Helmet>
                <title>{`Best Premium Quality ${main} Online at Triokzz`}</title>
                <meta name="description"
                    content={`Get pure authentic ${main} products.Transparently sourced from trusted partners with clear pricing and easy returns`}>
                </meta>
                <meta name="robots" content="index, follow, max-image-preview:large" />
                <meta name="keywords" content="millets, ghee, bilona ghee, a2, vedic power, powder, Organic Products, empower, Go Organic, Organic soil product, Triorgz"></meta>
                <link rel="canonical" href={`https://www.triokzz.com/list/grocery/${main}`} />
                <meta property="og:type" content="website" />
                <meta property="og:title" content="Curated indian grocery" />
                <meta property="og:description" content="On the Organic Supermarts Triokzz focuses on empowering ORGANIC PRODUCTS sellers across India" />
                <meta property="og:image" content="https://shopnowindia.s3.ap-south-1.amazonaws.com/organic_product/grocery2.png" />
                <meta property="og:image:width" content="1200" />
                <meta property="og:image:height" content="630" />
                <meta property="og:url" content={`https://www.triokzz.com/list/grocery/${main}`} />
                <meta property="og:image:alt" content="bhartiya organic product spicy masale bilona ghee vedic food dry fruits cold press oil millets" />
                <meta property="og:site_name" content="Triokzz" />
                <meta property="og:image:type" content="image/jpeg" />
                <meta property="og:locale" content="en_IN" />
                <meta property="twitter:card" content={`${main}`} />
                <meta property="twitter:url" content={`https://www.triokzz.com/list/grocery/${main}`} />
                <meta property="twitter:title" content={`${main}`} />
                <meta property="twitter:description" content="On the Organic Supermarts Triokzz focuses on empowering ORGANIC PRODUCTS sellers across India." />
                <meta property="twitter:image" content="https://shopnowindia.s3.ap-south-1.amazonaws.com/organic_product/grocery2.png" />
            </Helmet >

            <ProductNav {...props} onSelectNavItem={onSelectNavItem} onfilter={onfilter} onshoppingRender={onshoppingRender} selectedItem={addtocard && addtocard.length} setShowChild={setShowChild}/>
            <h1 className="max-w-2xl mx-auto text-center font-manrope font-bold text-xl text-gray-900 mb-2 md:text-xl leading-[50px]">Authentic {main} & Wellness Essentials</h1>
            <h2 className="capitalize text-sm text-sky-600">At Triokzz, we curate authentic {main} and wellness essentials sourced from trusted partners who follow traditional preparation methods.
Our focus is on transparency—clear product details, honest sourcing information, and straightforward policies—so you can shop with confidence.
</h2>
              {siginUserInfo ? "" : showChild ? <OfferCard navItem={main} setShowChild={setShowChild}/> : ""}
            <div className="flex  overflow-y-scroll pb-2 hide-scroll-bar rounded-lg">
                <ul className="flex flex-nowrap">
                    {menuproduct && menuproduct.products && menuproduct.products.map((val, i) => {
                        return (<li key={i}
                            onClick={() => onitemSelect(val.product_for)}
                            className="p-1 flex items-center flex-col border border-gray-200 shadow-2xs rounded-xl hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-1 py-1 text-center me-2 m-2"
                        id="data-is-loaded-element"
                        >
                            <div >
                                {/* <amp-img
                                    alt="grocery"
                                    src={val.image ? val.image : "https://shopnowindia.s3.ap-south-1.amazonaws.com/organic_product/Triorg.png"}
                                    width="1080"
                                    height="1080"
                                    layout="responsive"
                                >
                                </amp-img> */}
                                <OptimizedImage src={val.image ? val.image : "https://shopnowindia.s3.ap-south-1.amazonaws.com/organic_product/Triorg.png"} alt="grocery" className="ml-4 rounded-full w-16 h-16 object-cover" title="Decorate your home with triokzz"/>
                                <h5 className="capitalize truncate text-sm w-24 text-sky-600">{val.product_for}</h5>
                            </div>
                        </li>)
                    }
                    )
                    }
                </ul>
            </div>
            <hr className="border-b-2 rounded-md drop-shadow-lg "></hr>
            <div className="scroll-left flex bg-gradient-to-tr from-indigo-600 via-pink-600 to-purple-600">
            <div className="flex w-full h-20 capitalize text-lg font-medium text-white">
                    <h2 className="flex capitalize text-lg font-medium text-white">Fastest Delivery Network. Best Selective {main} Products Trusted By The World’s Most Innovative Teams. Product partner- JiGari, Bhavna Art,PriyankaFarm, Manas Jaivik Food </h2>

                </div>
            </div>
            <div className="relative mx-auto max-w-2xl px-2 py-2 sm:px-6 sm:py-6 lg:max-w-7xl lg:px-8  " >
                <div className="mt-2 mr-2 grid grid-cols-1 gap-x-6 gap-y-10 sm:grid-cols-1 lg:grid-cols-1 md:grid-cols-1 xl:gap-x-2">
                    {serchableoutput.length > 0 ? serchableoutput.map((val, id) => {

                        return (
                            <div key={val.uni_productId} className={val.freez ? "group relative cursor-not-allowed transformed opacity-25 bg-white flex" : "group relative bg-white flex"} onClick={() => onOpen(val)}>

                                <div className="aspect-h-1 aspect-w-1 w-48 overflow-hidden rounded-md bg-gray-200 lg:aspect-none group-hover:opacity-75 lg:h-48">
                                    <OptimizedImage
                                        src={val.url}
                                        alt={val.type}
                                        style={{ height: "190px", width: "100%", objectFit: "fill" }}
                                        width="100%"
                                        height="100%"
                                        className="h-full w-full object-cover object-center lg:h-full lg:w-full"
                                        title={val.product_name}
                                    />
                                    {val.freez && <span className="before:block before:absolute before:-inset-1 before:-skew-y-3 before:bg-green-500 relative inline-block">
                                        <span className="relative text-white">Sold out</span>
                                    </span>}
                                </div>
                                <div className="mt-8 justify-between w-48">
                                    <div>
                                        <h3 className="text-md text-gray-700">
                                            <span aria-hidden="true" className="absolute inset-0" />
                                            {val.brand}
                                        </h3>
                                        <p className="mt-1 text-md text-gray-500">{val.color}</p>
                                    </div>

                                    <div>
                                        <h3 className="text-sm mt-4 font-medium text-green"><span className="text-md text-gray-700">Offer Price:</span>{val.offer_prize}</h3>
                                        <p className="text-sm font-medium text-red-900 line-through"><span className="text-sm text-gray-700">Real Price:</span>{val.real_prize}</p>
                                    </div>
                                </div>
                            </div>
                        )
                    }) : <div className="relative  grid grid-cols-1 w-full" >
                        {/* <div className={navItem == "all" ? "container p-2 " : "container p-2 hidden"}>
                            <img src="https://static.sadhguru.org/d/46272/1646819925-cp-banner.jpg" className="col-span-2 col-start-2 max-h-28 w-full object-contain sm:col-start-auto lg:col-span-1" alt="Save Soil Save Life" title="Save Soil Save Life" />
                            <p className="ml-2 capitalize text-sm font-medium text-white font-semibold dark:text-white font-serif">We know who's gonna shine brighten this season, do you know who ? Its you .😃.  Because, all sale is here with best deals on latest styles 🫣</p>
                        </div> */}
                        <div className="bg-white py-2 sm:py-2 sr-only">
                            <div className="mx-auto max-w-7xl px-2 lg:px-8">

                                <h2 className="text-center text-md font-semibold leading-8 text-gray-900 ">
                                    <a href="https://triokzz.com/product/watchtv">Best Selective {main} Products Trusted By The World’s Most Innovative Teams</a>
                                </h2>
                            </div>
                        </div>
                    </div>
                    }

                </div>
            </div>
            <section className="relative">
            <div class="flex w-full items-center rounded-full" role="main">
                <div class="flex-1 border-b border-gray-300"></div>
                <h2 class="text-black text-lg font-semibold leading-8 px-8 py-3">Why Buy {main} from Triokzz?</h2>
                <div class="flex-1 border-b border-gray-300"></div>
            </div>
            <div class="flex flex-row-reverse space-x-4 space-x-reverse bg-orange-50 w-full text-center rounded-md p-4 ">

<div class="flex-1 py-3 bg-orange-100  rounded-lg">
    <h2 className="italic font-bold">Curated, not crowded</h2>
    <p class="line-clamp-3">
        Only products we trust ourselves. Transparent product information and pricing
    </p>
    <div>
    </div>
</div>
<div class="flex-1 py-3 bg-orange-100  rounded-lg">
    <h2 className="italic font-bold">Partner-led quality</h2>
    <p class="line-clamp-3">
        We work directly with authentic producers.
    </p>
    <div>
    </div>
</div>
<div class="flex-1 py-3 bg-orange-100  rounded-lg">
    <h2 className="italic font-bold">Tradition meets today</h2>
    <p class="line-clamp-3">
    Prepared using traditional methods (as stated by partners)
    </p>
    <div>
    </div>
</div>
</div>
                <div className="w-full max-w-7xl mx-auto px-4 md:px-8">
                    <div className="grid  gap-8">
                        <div className="col-span-10 lg:col-span-6 w-full items-center text-center justify-center">
                            <div className="container mx-auto">
                                <h5 className="text-4xl text-green-500 font-culpa">Organic World</h5>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <div className="mx-auto max-w-2xl px-1 py-1 sm:px-6 sm:py-2 lg:max-w-7xl lg:px-8 mt-1 bg-neutral-50"
            >
                {dialog ? <ProductDialog open={dialog} onOpen={() => onOpen} cardProduct={cardProduct} onAddToCard={onAddToCard} setDialog={setDialog} setShowChild={setShowChild} siginUserInfo={siginUserInfo}/> : ""}
                {openshopping ? <ShoppingCard openshopping={openshopping} setOpenShopping={setOpenShopping} onRemove={onRemove} onCount={onCount} onOpen={onOpen} setShowChild={setShowChild} /> : ""}

                {
                    GroceryProducts && GroceryProducts.section ? GroceryProducts && GroceryProducts.section && GroceryProducts.section.map((specialProd, i) => {
                        let [keys] = Object.keys(specialProd)
                        let arr = specialProd[keys]
                        // setProdkeys(arr)
                        // console.log(arr)
                        return (<div key={i} className="mt-6 grid grid-cols-2  sm:grid-cols-2 lg:grid-cols-4 md:grid-cols-3 xl:gap-x-8">
                            {/* <h4 class="text-2xl text-green-500 font-culpa tracking-tight ">{keys}</h4> */}
                            {arr ? arr.map((val, id) => {

                                return (
                                    <div key={id} className={val.freez ? "group relative cursor-not-allowed transformed opacity-40 bg-white" : "group relative border border-gray-200 bg-white drop-shadow-lg m-0.5 p-1 glass-card rounded-[20px] shadow-2xl overflow-hidden animate-float"}
                                     >
                                        <Helmet>
                                            <script type="application/ld+json">
                                                {`
      {
        "@context": "https://schema.org/",
        "@type": "Product",
        "name": "High-Quality ${val.product_name} by ${val.brand} Online",
        "alternateName":[${val.keywords.map((value,i)=>`"${value}"`)}],
        "image": [   "${val.url}", "${val.detail_url}"
         ],
        "description": "${val.product_detail}. Shop online for exclusive deals on ${val.keywords.map((value,i)=>value)}",
        "sku": "${val.id}-202",
        "mpn": "${(Math.random().toString(10).slice(2))}",
                             "potentialAction": {
          "@type": "SearchAction",
          "target": {
            "@type": "EntryPoint",
            "urlTemplate": "https://www.triokzz.com/search/?searchCategory=all&text={search_term_string}"
          },
          "query-input": "required name=search_term_string"
        },
        "brand": {
          "@type": "Brand",
          "name": "${val.brand}"
        },
        "review": {
          "@type": "Review",
          "reviewRating": {
            "@type": "Rating",
            "ratingValue": ${val.rating},
            "bestRating": 5
          },
          "author": {
            "@type": "Person",
            "name": "Pritam Maniyar"
          }
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": 4.4,
          "reviewCount": 3111
        },
        "offers": {
          "@type": "Offer",
          "url": "https://www.triokzz.com/list/grocery/${main}",
          "itemCondition": "https://schema.org/NewCondition",
          "availability": "https://schema.org/InStock",
          "price": ${val.offer_prize},
          "priceCurrency": "INR",
          "priceValidUntil": "2030-11-20",
          "shippingDetails": {
            "@type": "OfferShippingDetails",
            "shippingRate": {
              "@type": "MonetaryAmount",
              "value": 0.0,
              "currency": "INR"
            },
            "shippingDestination": {
              "@type": "DefinedRegion",
              "addressCountry": "IN"
            },
            "deliveryTime": {
              "@type": "ShippingDeliveryTime",
              "handlingTime": {
                "@type": "QuantitativeValue",
                "minValue": 0,
                "maxValue": 1,
                "unitCode": "DAY"
              },
              "transitTime": {
                "@type": "QuantitativeValue",
                "minValue": 1,
                "maxValue": 5,
                "unitCode": "DAY"
              }
            }
          },
          "hasMerchantReturnPolicy": {
            "@type": "MerchantReturnPolicy",
            "applicableCountry": "IN",
            "returnPolicyCategory": "https://schema.org/MerchantReturnFiniteReturnWindow",
            "merchantReturnDays": 30,
            "returnMethod": "https://schema.org/ReturnByMail",
            "returnFees": "https://schema.org/FreeReturn"
          }
        }
      }
    `}
                                            </script>
                                        </Helmet>
                                        <div className="relative aspect-h-1 aspect-w-1 w-full overflow-hidden bg-white">
                                            <div className="relative mx-1 mt-1 flex h-60 overflow-hidden ">
                                                {/* <div style={{ position: "relative", width: "100%", height: "100%" }}>
                                                    <amp-img
                                                        src={val ? val.url: ""}
                                                        layout="fill"
                                                        style={{ position: "absolute", objectFit: "contain", aspectRatio: "auto", width: "100%", height: "100%", }}
                                                        alt={val.product_for}
                                                    ></amp-img>
                                                </div> */}
                                                <OptimizedImage
                                                    src={val.url}
                                                    style={{ height: "220px", width: "100%", objectFit: "fill", aspectRatio: "auto" }}
                                                    width="1200"
                                                    height="800"
                                                    loading="lazy"
                                                    alt={val.type}
                                                    className="aspect-square bg-gray-100 rounded-lg flex items-center justify-center overflow-hidden"
                                                    title={val.product_name}
                                                    onClick={()=> navigate(`/organic-grocery/${main}/${val.type}${val.id}`)}
                                                />
                                                <span className="absolute top-0 left-0 m-1 bg-gradient-to-tr from-indigo-600 via-pink-600 to-purple-600 px-2 text-center text-sm font-medium text-white">{val.offer ? val.offer : ""
                                                }</span>
                                            </div>

                                            {val.freez ? <span className="absolute flex text-md text-amber-400 bottom-0 left-20 -translate-x-1/2 bg-red-600   inline-block">
                                                <span className="relative text-white">Sold Out</span>
                                            </span> : <span className="absolute h-5 flex text-md text-amber-400 bottom-0 left-28 -translate-x-2/3 bg-red-600 inline-block">
                                                <span className="flex items-center justify-center text-white text-sm  bg-black w-20 animate-[spin_3s_ease-in-out]"> {Math.floor(Math.abs(((val.offer_prize - val.real_prize) / val.real_prize) * 100))}  <span className="text-sm items-center justify-center">% off</span></span>
                                                <div className="flex items-center justify-center">
                                                    <svg className="w-4 h-4 text-yellow-300 me-1" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 22 20">
                                                        <path d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z" />
                                                    </svg>
                                                    <p className="mr-3 text-sm font-bold text-white dark:text-white">{val.rating}</p>
                                                </div>
                                                {val.delivery_charge == "00" ? <div className="flex items-center justify-center">
                                                    <img width="20" height="48" src="https://img.icons8.com/external-flat-gradient-andi-nur-abdillah/64/external-delivery-delivery-and-logistic-flat-gradient-flat-gradient-andi-nur-abdillah-2.png" alt=" external-delivery-delivery-and-logistic-flat-gradient-flat-gradient-andi-nur-abdillah-2" className='animate-bounce' />
                                                    <p className="mr-4 text-sm font-bold text-white dark:text-white">Free</p>
                                                </div> : ""}
                                            </span>

                                            }

                                        </div>
                                        <div className="grid grid-cols-1 justify-between">
                                            <div className="h-10 p-1 justify-between" onClick={() => onOpen(val)}>
                                                <h2 className="capitalize text-sm text-bold text-left font-semibold  line-clamp-2"><span>
                                                    {val.product_name}
                                                </span> </h2>
                                                <p className="sr-only">
                                                    {val.product_detail}
                                                </p>
                                            </div>
                                        </div>
                                        <div className="grid grid-cols-2 justify-between p-1">
                                            <div className="flex justify-between">
                                                <h3 className="capitalize truncate text-xs text-gray-700">
                                                    <span aria-hidden="true" className="absolute" />
                                                    {val.color}
                                                </h3>
                                                {/* <p rel="schema:name" className="mt-1 text-xs text-gray-500"><span property="schema:name">{val.type}</span> {val.color}</p> */}
                                            </div>
                                            <div className="justify-between">
                                                <p className="text-xs font-medium text-green"><span>₹ {val.offer_prize}</span>/-<span className="text-xs  text-gray-700 line-through"> {val.real_prize}  </span></p>

                                            </div>
                                        </div>
                                        <div className=" grid grid-cols-1 text-center justify-between drop-shadow-lg" >
                                            <div>
                                                <p className="text-xs font-medium text-green">Size:-{val.size}</p>
                                            </div>
                                            <div className='h-6'>
                                        {val.offer_prize > 999 && <div className="justify-between text-start p-1">
                                                <p className="relative text-[10px] font-bold text-green-700">Final Price ₹{(val.offer_prize - (val.offer_prize*(10/100)))} <span className='text-[9px]'>(Coupon Applied)</span></p>
                                            </div>}
                                </div>
                                            {!val.freez ? <div className="relative p-1 flex items-center justify-center hover:scale-125  transition" onClick={() => onAddToCard({
                                                name: val.brand,
                                                product_name: val.product_name,
                                                price: val.offer_prize,
                                                real_prize: val.real_prize,
                                                id: val.id,
                                                count: val.count,
                                                rating: 3.9,
                                                reviewCount: 117,
                                                imageSrc: val.url,
                                                imageAlt: val.brand,
                                                colors: { name: val.color, class: 'bg-gray-900', selectedClass: 'ring-gray-900' },
                                                sizes: { name: val.size[0], inStock: true },
                                                size: val.size,
                                                uni_productId: val.uni_productId,
                                                type: val.type,
                                                detail: val.product_name + val.product_detail,
                                                detail_url: val.detail_url,
                                                delivery_charge: val.delivery_charge,
                                                navItem:main,
                                                keywords:val.keywords
                                            })}>
                                                <a
                                                    href="#"
                                                    className="flex w-3/4 item-center justify-center active:translate-y-2  active:[box-shadow:0_0px_0_0_#1b6ff8,0_0px_0_0_#1b70f841]
                                                    active:border-b-[0px] transition-all duration-150
                                                    border border-black  text-black p-1 glass-card rounded-[20px] shadow-2xl overflow-hidden animate-float hover:bg-indigo-700"
                                                >
                                                    Add to Card
                                                </a>

                                            </div> : <div className="relative p-1 flex tems-center justify-center">
                                                <a
                                                    href="#"
                                                    className="flex w-3/4 item-center justify-center rounded-md border border border-indigo-300 bg-red-600 text-white px-1 py-1 text-base font-small shadow-sm hover:bg-indigo-700"
                                                >
                                                    Not Available
                                                </a>

                                            </div>}
                                        </div>



                                    </div>
                                )
                            }) : ""}

                        </div>
                        )
                    })
                        : <div role="status" className="max-w-sm p-4 border border-gray-200 rounded shadow animate-pulse md:p-6 dark:border-gray-700">
                            <div className="flex items-center justify-center h-48 mb-4 bg-gray-300 rounded dark:bg-gray-700">
                                <svg className="w-10 h-10 text-gray-200 dark:text-gray-600" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 20">
                                    <path d="M14.066 0H7v5a2 2 0 0 1-2 2H0v11a1.97 1.97 0 0 0 1.934 2h12.132A1.97 1.97 0 0 0 16 18V2a1.97 1.97 0 0 0-1.934-2ZM10.5 6a1.5 1.5 0 1 1 0 2.999A1.5 1.5 0 0 1 10.5 6Zm2.221 10.515a1 1 0 0 1-.858.485h-8a1 1 0 0 1-.9-1.43L5.6 10.039a.978.978 0 0 1 .936-.57 1 1 0 0 1 .9.632l1.181 2.981.541-1a.945.945 0 0 1 .883-.522 1 1 0 0 1 .879.529l1.832 3.438a1 1 0 0 1-.031.988Z" />
                                    <path d="M5 5V.13a2.96 2.96 0 0 0-1.293.749L.879 3.707A2.98 2.98 0 0 0 .13 5H5Z" />
                                </svg>
                            </div>
                            <div className="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-48 mb-4"></div>
                            <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-700 mb-2.5"></div>
                            <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-700 mb-2.5"></div>
                            <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-700"></div>
                            <div className="flex items-center mt-4">
                                <svg className="w-10 h-10 me-3 text-gray-200 dark:text-gray-700" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                                    <path d="M10 0a10 10 0 1 0 10 10A10.011 10.011 0 0 0 10 0Zm0 5a3 3 0 1 1 0 6 3 3 0 0 1 0-6Zm0 13a8.949 8.949 0 0 1-4.951-1.488A3.987 3.987 0 0 1 9 13h2a3.987 3.987 0 0 1 3.951 3.512A8.949 8.949 0 0 1 10 18Z" />
                                </svg>
                                <div>
                                    <div className="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-32 mb-2"></div>
                                    <div className="w-48 h-2 bg-gray-200 rounded-full dark:bg-gray-700"></div>
                                </div>
                            </div>
                            <span className="sr-only">Loading...</span>
                        </div>}
                        <div class="flex flex-col md:flex-row justify-between items-center mt-6">
      <div className="flex space-x-2 justify-center items-center" >
        <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR-v52tLnvL3FEjfxjPvZWbvUMYvVUtAm9R6A&s" alt="Google Play" class="h-10 w-1/2" onClick={()=> window.location.replace(`https://play.google.com/store/apps/details?id=com.triokzz.app`)}/>
        {/* <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSJgk5tpxJC_1CAnsXwo2VvBGyQGI-o5c1PJw&s" alt="App Store" class="h-10"/> */}
      </div>
      <div class="flex space-x-2 mt-4 md:mt-0">
        <img src="https://www.logo.wine/a/logo/Apple_Pay/Apple_Pay-White-Dark-Background-Logo.wine.svg" alt="Apple Pay" class="h-[30px] w-10 rounded-md" width="100%" height="100%"/>
        <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSynWEtLag--sQ4XlfTwHh9_DAnfcglW7C3iw&s" alt="Visa" class="h-[30px] w-10 rounded-md" width="100%" height="100%"/>
        <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT6mJsEDg1aR_JCFb3ohk2nCxjgSvkWnpmlKg&s" alt="Mastercard" class="h-[30px] w-10 rounded-md" width="100%" height="100%"/>
        <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQveKfGcJ1tSEY8bLg52DxvVrFDJXmxXJgv1Q&s" alt="discover" class="h-[30px] w-10 rounded-md" width="100%" height="100%"/>
        <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSDS0zyuJdI4e7E1VGaNDAVtRn3fGTzr0PBOA&s" alt="Secure Payment" class="h-[30px] w-10 rounded-md" width="100%" height="100%"/>
      </div>
      <div className="flex mt-4 space-x-2 sm:justify-center sm:mt-0">
                    
                    <a href="https://www.facebook.com/profile.php?id=61553460826080&mibexid=ZbWKwL" className="w-12 h-12 flex items-center justify-center bg-gradient-to-tr from-red-50 to-pink-50 cursor-pointer rounded-md shadow-md shadow-transparent transition-all duration-300 hover:shadow-red-200" role="button">
                        <svg class="" xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 92 92" fill="none">
                            <rect x="0.138672" rx="15" fill="#EDF4FF" />
                            <path d="M56.4927 48.6403L57.7973 40.3588H49.7611V34.9759C49.7611 32.7114 50.883 30.4987 54.4706 30.4987H58.1756V23.4465C56.018 23.1028 53.8378 22.9168 51.6527 22.8901C45.0385 22.8901 40.7204 26.8626 40.7204 34.0442V40.3588H33.3887V48.6403H40.7204V68.671H49.7611V48.6403H56.4927Z" fill="#337FFF" />
                        </svg>
                    </a>

                    <a href="https://www.instagram.com/triokzz?igsh=MWUzM3dweTNyY2NpeA==" className="w-12 h-12 flex items-center justify-center bg-gradient-to-tr from-red-50 to-pink-50 cursor-pointer rounded-md shadow-md shadow-transparent transition-all duration-300 hover:shadow-red-200" role="button">
                        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 51 51" fill="none">
                            <path d="M17.4456 25.7808C17.4456 21.1786 21.1776 17.4468 25.7826 17.4468C30.3875 17.4468 34.1216 21.1786 34.1216 25.7808C34.1216 30.383 30.3875 34.1148 25.7826 34.1148C21.1776 34.1148 17.4456 30.383 17.4456 25.7808ZM12.9377 25.7808C12.9377 32.8708 18.6883 38.618 25.7826 38.618C32.8768 38.618 38.6275 32.8708 38.6275 25.7808C38.6275 18.6908 32.8768 12.9436 25.7826 12.9436C18.6883 12.9436 12.9377 18.6908 12.9377 25.7808ZM36.1342 12.4346C36.1339 13.0279 36.3098 13.608 36.6394 14.1015C36.9691 14.595 37.4377 14.9797 37.9861 15.2069C38.5346 15.4342 39.1381 15.4939 39.7204 15.3784C40.3028 15.2628 40.8378 14.9773 41.2577 14.5579C41.6777 14.1385 41.9638 13.6041 42.0799 13.0222C42.1959 12.4403 42.1367 11.8371 41.9097 11.2888C41.6828 10.7406 41.2982 10.2719 40.8047 9.94202C40.3112 9.61218 39.7309 9.436 39.1372 9.43576H39.136C38.3402 9.43613 37.5771 9.75216 37.0142 10.3144C36.4514 10.8767 36.1349 11.6392 36.1342 12.4346ZM15.6765 46.1302C13.2377 46.0192 11.9121 45.6132 11.0311 45.2702C9.86323 44.8158 9.02993 44.2746 8.15381 43.4002C7.27768 42.5258 6.73536 41.6938 6.28269 40.5266C5.93928 39.6466 5.53304 38.3214 5.42217 35.884C5.3009 33.2488 5.27668 32.4572 5.27668 25.781C5.27668 19.1048 5.3029 18.3154 5.42217 15.678C5.53324 13.2406 5.94248 11.918 6.28269 11.0354C6.73736 9.86816 7.27888 9.03536 8.15381 8.15976C9.02873 7.28416 9.86123 6.74216 11.0311 6.28976C11.9117 5.94656 13.2377 5.54056 15.6765 5.42976C18.3133 5.30856 19.1054 5.28436 25.7826 5.28436C32.4598 5.28436 33.2527 5.31056 35.8916 5.42976C38.3305 5.54076 39.6539 5.94976 40.537 6.28976C41.7049 6.74216 42.5382 7.28536 43.4144 8.15976C44.2905 9.03416 44.8308 9.86816 45.2855 11.0354C45.6289 11.9154 46.0351 13.2406 46.146 15.678C46.2673 18.3154 46.2915 19.1048 46.2915 25.781C46.2915 32.4572 46.2673 33.2466 46.146 35.884C46.0349 38.3214 45.6267 39.6462 45.2855 40.5266C44.8308 41.6938 44.2893 42.5266 43.4144 43.4002C42.5394 44.2738 41.7049 44.8158 40.537 45.2702C39.6565 45.6134 38.3305 46.0194 35.8916 46.1302C33.2549 46.2514 32.4628 46.2756 25.7826 46.2756C19.1024 46.2756 18.3125 46.2514 15.6765 46.1302ZM15.4694 0.932162C12.8064 1.05336 10.9867 1.47536 9.39755 2.09336C7.75177 2.73156 6.35853 3.58776 4.9663 4.97696C3.57406 6.36616 2.71955 7.76076 2.08097 9.40556C1.46259 10.9948 1.04034 12.8124 0.919069 15.4738C0.795795 18.1394 0.767578 18.9916 0.767578 25.7808C0.767578 32.57 0.795795 33.4222 0.919069 36.0878C1.04034 38.7494 1.46259 40.5668 2.08097 42.156C2.71955 43.7998 3.57426 45.196 4.9663 46.5846C6.35833 47.9732 7.75177 48.8282 9.39755 49.4682C10.9897 50.0862 12.8064 50.5082 15.4694 50.6294C18.138 50.7506 18.9893 50.7808 25.7826 50.7808C32.5759 50.7808 33.4286 50.7526 36.0958 50.6294C38.759 50.5082 40.5774 50.0862 42.1676 49.4682C43.8124 48.8282 45.2066 47.9738 46.5989 46.5846C47.9911 45.1954 48.8438 43.7998 49.4842 42.156C50.1026 40.5668 50.5268 38.7492 50.6461 36.0878C50.7674 33.4202 50.7956 32.57 50.7956 25.7808C50.7956 18.9916 50.7674 18.1394 50.6461 15.4738C50.5248 12.8122 50.1026 10.9938 49.4842 9.40556C48.8438 7.76176 47.9889 6.36836 46.5989 4.97696C45.2088 3.58556 43.8124 2.73156 42.1696 2.09336C40.5775 1.47536 38.7588 1.05136 36.0978 0.932162C33.4306 0.810962 32.5779 0.780762 25.7846 0.780762C18.9913 0.780762 18.138 0.808962 15.4694 0.932162Z" fill="url(#paint0_radial_7092_54379)" />
                            <path d="M17.4456 25.7808C17.4456 21.1786 21.1776 17.4468 25.7826 17.4468C30.3875 17.4468 34.1216 21.1786 34.1216 25.7808C34.1216 30.383 30.3875 34.1148 25.7826 34.1148C21.1776 34.1148 17.4456 30.383 17.4456 25.7808ZM12.9377 25.7808C12.9377 32.8708 18.6883 38.618 25.7826 38.618C32.8768 38.618 38.6275 32.8708 38.6275 25.7808C38.6275 18.6908 32.8768 12.9436 25.7826 12.9436C18.6883 12.9436 12.9377 18.6908 12.9377 25.7808ZM36.1342 12.4346C36.1339 13.0279 36.3098 13.608 36.6394 14.1015C36.9691 14.595 37.4377 14.9797 37.9861 15.2069C38.5346 15.4342 39.1381 15.4939 39.7204 15.3784C40.3028 15.2628 40.8378 14.9773 41.2577 14.5579C41.6777 14.1385 41.9638 13.6041 42.0799 13.0222C42.1959 12.4403 42.1367 11.8371 41.9097 11.2888C41.6828 10.7406 41.2982 10.2719 40.8047 9.94202C40.3112 9.61218 39.7309 9.436 39.1372 9.43576H39.136C38.3402 9.43613 37.5771 9.75216 37.0142 10.3144C36.4514 10.8767 36.1349 11.6392 36.1342 12.4346ZM15.6765 46.1302C13.2377 46.0192 11.9121 45.6132 11.0311 45.2702C9.86323 44.8158 9.02993 44.2746 8.15381 43.4002C7.27768 42.5258 6.73536 41.6938 6.28269 40.5266C5.93928 39.6466 5.53304 38.3214 5.42217 35.884C5.3009 33.2488 5.27668 32.4572 5.27668 25.781C5.27668 19.1048 5.3029 18.3154 5.42217 15.678C5.53324 13.2406 5.94248 11.918 6.28269 11.0354C6.73736 9.86816 7.27888 9.03536 8.15381 8.15976C9.02873 7.28416 9.86123 6.74216 11.0311 6.28976C11.9117 5.94656 13.2377 5.54056 15.6765 5.42976C18.3133 5.30856 19.1054 5.28436 25.7826 5.28436C32.4598 5.28436 33.2527 5.31056 35.8916 5.42976C38.3305 5.54076 39.6539 5.94976 40.537 6.28976C41.7049 6.74216 42.5382 7.28536 43.4144 8.15976C44.2905 9.03416 44.8308 9.86816 45.2855 11.0354C45.6289 11.9154 46.0351 13.2406 46.146 15.678C46.2673 18.3154 46.2915 19.1048 46.2915 25.781C46.2915 32.4572 46.2673 33.2466 46.146 35.884C46.0349 38.3214 45.6267 39.6462 45.2855 40.5266C44.8308 41.6938 44.2893 42.5266 43.4144 43.4002C42.5394 44.2738 41.7049 44.8158 40.537 45.2702C39.6565 45.6134 38.3305 46.0194 35.8916 46.1302C33.2549 46.2514 32.4628 46.2756 25.7826 46.2756C19.1024 46.2756 18.3125 46.2514 15.6765 46.1302ZM15.4694 0.932162C12.8064 1.05336 10.9867 1.47536 9.39755 2.09336C7.75177 2.73156 6.35853 3.58776 4.9663 4.97696C3.57406 6.36616 2.71955 7.76076 2.08097 9.40556C1.46259 10.9948 1.04034 12.8124 0.919069 15.4738C0.795795 18.1394 0.767578 18.9916 0.767578 25.7808C0.767578 32.57 0.795795 33.4222 0.919069 36.0878C1.04034 38.7494 1.46259 40.5668 2.08097 42.156C2.71955 43.7998 3.57426 45.196 4.9663 46.5846C6.35833 47.9732 7.75177 48.8282 9.39755 49.4682C10.9897 50.0862 12.8064 50.5082 15.4694 50.6294C18.138 50.7506 18.9893 50.7808 25.7826 50.7808C32.5759 50.7808 33.4286 50.7526 36.0958 50.6294C38.759 50.5082 40.5774 50.0862 42.1676 49.4682C43.8124 48.8282 45.2066 47.9738 46.5989 46.5846C47.9911 45.1954 48.8438 43.7998 49.4842 42.156C50.1026 40.5668 50.5268 38.7492 50.6461 36.0878C50.7674 33.4202 50.7956 32.57 50.7956 25.7808C50.7956 18.9916 50.7674 18.1394 50.6461 15.4738C50.5248 12.8122 50.1026 10.9938 49.4842 9.40556C48.8438 7.76176 47.9889 6.36836 46.5989 4.97696C45.2088 3.58556 43.8124 2.73156 42.1696 2.09336C40.5775 1.47536 38.7588 1.05136 36.0978 0.932162C33.4306 0.810962 32.5779 0.780762 25.7846 0.780762C18.9913 0.780762 18.138 0.808962 15.4694 0.932162Z" fill="url(#paint1_radial_7092_54379)" />
                            <defs>
                                <radialGradient id="paint0_radial_7092_54379" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(7.41436 51.017) scale(65.31 65.2708)">
                                    <stop offset="0.09" stop-color="#FA8F21" />
                                    <stop offset="0.78" stop-color="#D82D7E" />
                                </radialGradient>
                                <radialGradient id="paint1_radial_7092_54379" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(31.1086 53.257) scale(51.4733 51.4424)">
                                    <stop offset="0.64" stop-color="#8C3AAA" stop-opacity="0" />
                                    <stop offset="1" stop-color="#8C3AAA" />
                                </radialGradient>
                            </defs>
                        </svg>
                    </a>

                    <a href="https://x.com/triokzz" role="button">
                        <svg class="cursor-pointer rounded-md shadow-md shadow-transparent transition-all duration-300 hover:shadow-indigo-200" xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 93 92" fill="none">
                            <rect x="0.138672" width="91.5618" height="91.5618" rx="15" fill="#F7F7F7" />
                            <path d="M50.7568 42.1716L69.3704 21H64.9596L48.7974 39.383L35.8887 21H21L40.5205 48.7983L21 71H25.4111L42.4788 51.5869L56.1113 71H71L50.7557 42.1716H50.7568ZM44.7152 49.0433L42.7374 46.2752L27.0005 24.2492H33.7756L46.4755 42.0249L48.4533 44.7929L64.9617 67.8986H58.1865L44.7152 49.0443V49.0433Z" fill="black" />
                        </svg></a>
                    <a href="https://www.linkedin.com/company/triokzz" role="button">
                        <svg class="cursor-pointer rounded-md shadow-md shadow-transparent transition-all duration-300 hover:shadow-blue-200" xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 92 93" fill="none">
                            <rect x="0.138672" y="1" width="91.5618" height="91.5618" rx="15" fill="#EEFAFF" />
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M24.6975 21.5618C22.6561 21.5618 21 23.1674 21 25.1456V68.0091C21 69.9875 22.6563 71.5918 24.6975 71.5918H67.3325C69.3747 71.5918 71.03 69.9873 71.03 68.0086V25.1456C71.03 23.1674 69.3747 21.5618 67.3325 21.5618H24.6975ZM36.2032 40.9068V63.4304H28.7167V40.9068H36.2032ZM36.6967 33.9411C36.6967 36.1025 35.0717 37.8321 32.4615 37.8321L32.4609 37.8319H32.4124C29.8998 37.8319 28.2754 36.1023 28.2754 33.9409C28.2754 31.7304 29.9489 30.0491 32.5111 30.0491C35.0717 30.0491 36.6478 31.7304 36.6967 33.9411ZM47.833 63.4304H40.3471L40.3469 63.4312C40.3469 63.4312 40.4452 43.0205 40.3475 40.9075H47.8336V44.0957C48.8288 42.5613 50.6098 40.3787 54.5808 40.3787C59.5062 40.3787 63.1991 43.598 63.1991 50.516V63.4304H55.7133V51.3822C55.7133 48.354 54.6293 46.2887 51.921 46.2887C49.8524 46.2887 48.6206 47.6815 48.0796 49.0271C47.8819 49.5072 47.833 50.1813 47.833 50.8535V63.4304Z" fill="#006699" />
                        </svg>
                    </a>
            </div>
    </div>
                {/* <h1 className="flex h-10 items-center justify-center bg-indigo-600 px-4 text-sm font-medium text-white sm:px-6 lg:px-8">
                    {navItem} products at one place.
                </h1> */}
                {/* <h2 className="flex items-center bg-indigo-600 text-white font-semibold">Free shipping on all orders of Rs 1449 and above. All product shall be dispatched with 24-48 hours excepts on bank holiday.
                    Delivery within india is Completed withing 5-10 working days depends on location.
                </h2> */}

                {/* 
    more product */}


                {/* remove after implimentation */}
            </div >
            {/* <div className="group fixed bottom-0 right-0 top-5 p-2  flex items-end justify-end w-24 h-24 ">
                <div className="text-white shadow-xl flex items-center justify-center p-2 rounded-full bg-gradient-to-r from-cyan-500 to-blue-500 z-50 absolute  ">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="1.5"
                        stroke="currentColor"
                        class="animate-bounce h-6 w-6"
                        onClick={() => scrolltobottom()} >
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M9 12.75l3 3m0 0l3-3m-3 3v-7.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                </div>
            </div> */}
       {/* <GoogleReviews placeId="ChIJa1IpjXdKaIMRhZh-LmXARxs"/> */}

            <div className="w-full">
                <div id="bottom-navigation" className="md:hidden block fixed inset-x-0 bottom-0 z-10 bg-white shadow">
                    {/* <div id="bottom-navigation" className="block fixed inset-x-0 bottom-0 z-10 bg-white shadow"> */}
                    <div id="tabs" className="flex justify-between">
                        <a href="/product/all" className="w-full focus:text-teal-500 hover:text-teal-500 justify-center inline-block text-center pt-2 pb-1">
                            <svg width="25" height="25" viewBox="0 0 42 42" className="inline-block mb-1">
                                <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                    <path d="M21.0847458,3.38674884 C17.8305085,7.08474576 17.8305085,10.7827427 21.0847458,14.4807396 C24.3389831,18.1787365 24.3389831,22.5701079 21.0847458,27.6548536 L21.0847458,42 L8.06779661,41.3066256 L6,38.5331279 L6,26.2681048 L6,17.2542373 L8.88135593,12.4006163 L21.0847458,2 L21.0847458,3.38674884 Z" fill="currentColor" fillOpacity="0.1"></path>
                                    <path d="M11,8 L33,8 L11,8 Z M39,17 L39,36 C39,39.3137085 36.3137085,42 33,42 L11,42 C7.6862915,42 5,39.3137085 5,36 L5,17 L7,17 L7,36 C7,38.209139 8.790861,40 11,40 L33,40 C35.209139,40 37,38.209139 37,36 L37,17 L39,17 Z" fill="currentColor"></path>
                                    <path d="M22,27 C25.3137085,27 28,29.6862915 28,33 L28,41 L16,41 L16,33 C16,29.6862915 18.6862915,27 22,27 Z" stroke="currentColor" strokeWidth="2" fill="currentColor" fillOpacity="0.1"></path>
                                    <rect fill="currentColor" transform="translate(32.000000, 11.313708) scale(-1, 1) rotate(-45.000000) translate(-32.000000, -11.313708) " x="17" y="10.3137085" width="30" height="2" rx="1"></rect>
                                    <rect fill="currentColor" transform="translate(12.000000, 11.313708) rotate(-45.000000) translate(-12.000000, -11.313708) " x="-3" y="10.3137085" width="30" height="2" rx="1"></rect>
                                </g>
                            </svg>
                            <span className="sr-only">Go Organic with triokzz.  To get most trusted product. You almost be here.Triokzz always shake hands to save soil. We are selling partner.
                            </span>

                            <span className="tab tab-home block text-xs">LifeStyle</span>
                        </a>
                        <a href="/list/grocery/Millets" className="w-full focus:text-teal-500 hover:text-teal-500 justify-center inline-block text-center pt-2 pb-1">
                            <svg width="25" height="25" viewBox="0 0 42 42" className="inline-block mb-1">
                                <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                    <path d="M14.7118754,20.0876892 L8.03575361,20.0876892 C5.82661462,20.0876892 4.03575361,18.2968282 4.03575361,16.0876892 L4.03575361,12.031922 C4.03575361,8.1480343 6.79157254,4.90780265 10.4544842,4.15995321 C8.87553278,8.5612583 8.1226025,14.3600511 10.9452499,15.5413938 C13.710306,16.6986332 14.5947501,18.3118357 14.7118754,20.0876892 Z M14.2420017,23.8186831 C13.515543,27.1052019 12.7414284,30.2811559 18.0438552,31.7330419 L18.0438552,33.4450645 C18.0438552,35.6542035 16.2529942,37.4450645 14.0438552,37.4450645 L9.90612103,37.4450645 C6.14196811,37.4450645 3.09051926,34.3936157 3.09051926,30.6294627 L3.09051926,27.813861 C3.09051926,25.604722 4.88138026,23.813861 7.09051926,23.813861 L14.0438552,23.813861 C14.1102948,23.813861 14.1763561,23.8154808 14.2420017,23.8186831 Z M20.7553776,32.160536 C23.9336213,32.1190063 23.9061943,29.4103976 33.8698747,31.1666916 C34.7935223,31.3295026 35.9925894,31.0627305 37.3154077,30.4407183 C37.09778,34.8980343 33.4149547,38.4450645 28.9036761,38.4450645 C24.9909035,38.4450645 21.701346,35.7767637 20.7553776,32.160536 Z" fill="currentColor" opacity="0.1"></path>
                                    <g transform="translate(2.000000, 3.000000)">
                                        <path d="M8.5,1 C4.35786438,1 1,4.35786438 1,8.5 L1,13 C1,14.6568542 2.34314575,16 4,16 L13,16 C14.6568542,16 16,14.6568542 16,13 L16,4 C16,2.34314575 14.6568542,1 13,1 L8.5,1 Z" stroke="currentColor" strokeWidth="2"></path>
                                        <path d="M4,20 C2.34314575,20 1,21.3431458 1,23 L1,27.5 C1,31.6421356 4.35786438,35 8.5,35 L13,35 C14.6568542,35 16,33.6568542 16,32 L16,23 C16,21.3431458 14.6568542,20 13,20 L4,20 Z" stroke="currentColor" strokeWidth="2"></path>
                                        <path d="M23,1 C21.3431458,1 20,2.34314575 20,4 L20,13 C20,14.6568542 21.3431458,16 23,16 L32,16 C33.6568542,16 35,14.6568542 35,13 L35,8.5 C35,4.35786438 31.6421356,1 27.5,1 L23,1 Z" stroke="currentColor" strokeWidth="2"></path>
                                        <path d="M34.5825451,33.4769886 L38.3146092,33.4322291 C38.8602707,33.4256848 39.3079219,33.8627257 39.3144662,34.4083873 C39.3145136,34.4123369 39.3145372,34.4162868 39.3145372,34.4202367 L39.3145372,34.432158 C39.3145372,34.9797651 38.8740974,35.425519 38.3265296,35.4320861 L34.5944655,35.4768456 C34.048804,35.4833899 33.6011528,35.046349 33.5946085,34.5006874 C33.5945611,34.4967378 33.5945375,34.4927879 33.5945375,34.488838 L33.5945375,34.4769167 C33.5945375,33.9293096 34.0349773,33.4835557 34.5825451,33.4769886 Z" fill="currentColor" transform="translate(36.454537, 34.454537) rotate(-315.000000) translate(-36.454537, -34.454537) "></path>
                                        <circle stroke="currentColor" strokeWidth="2" cx="27.5" cy="27.5" r="7.5"></circle>
                                    </g>
                                </g>
                            </svg>
                            <span className="sr-only">If you really want to buy organic millets this is best platform for you. Triokzz Marketing Team roam around India and get best products for you. Shop Now.</span>
                            <span className="tab tab-kategori block text-xs">Millets</span>
                        </a>
                        <a href="/list/grocery/Spice-Masale" className="w-full focus:text-teal-500 hover:text-teal-500 justify-center inline-block text-center pt-2 pb-1">
                            <svg width="25" height="25" viewBox="0 0 42 42" className="inline-block mb-1">
                                <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                    <path d="M20.5890101,0.254646884 C12.8696785,5.50211755 8.0025785,14.258415 14.1941217,18.8708225 C23.16683,25.5550669 13.3362326,40.2698884 33.1021758,38.4149164 C29.6814884,40.8311956 25.5065164,42.2507054 21,42.2507054 C9.40202025,42.2507054 0,32.8486852 0,21.2507054 C0,9.79003409 9.18071714,0.473634138 20.5890101,0.254646884 Z" fill="currentColor" opacity="0.1"></path>
                                    <path d="M25.9500282,20.3643496 L22.4308312,38.2677802 C22.3775703,38.5387376 22.1147395,38.7152155 21.8437821,38.6619546 C21.6570955,38.6252584 21.507413,38.4857901 21.4576354,38.3021581 L16.5951895,20.3643496 L20.099732,4.44663907 C20.1385204,4.27046145 20.2692032,4.12883813 20.4417012,4.07604096 C20.7057521,3.99522179 20.9853245,4.14376046 21.0661436,4.40781135 L25.9500282,20.3643496 Z M21.3022963,22.2852638 C22.4068658,22.2852638 23.3022963,21.3898333 23.3022963,20.2852638 C23.3022963,19.1806943 22.4068658,18.2852638 21.3022963,18.2852638 C20.1977268,18.2852638 19.3022963,19.1806943 19.3022963,20.2852638 C19.3022963,21.3898333 20.1977268,22.2852638 21.3022963,22.2852638 Z" fill="currentColor" transform="translate(21.272609, 20.629524) rotate(-315.000000) translate(-21.272609, -20.629524) "></path>
                                    <circle stroke="currentColor" strokeWidth="2" cx="21" cy="21" r="20"></circle>
                                </g>
                            </svg>
                            <span className="sr-only">Flavore your spicy world with Triorz spice masale. </span>

                            <span className="tab tab-explore block text-xs">Spice Factory</span>
                        </a>
                        <a href="#" onClick={() => onshoppingRender()} className="w-full focus:text-teal-500 hover:text-teal-500 justify-center inline-block text-center pt-2 pb-1">
                            <svg width="25" height="25" viewBox="0 0 42 42" className="inline-block mb-1">
                                <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                    <path d="M14.7118754,20.0876892 L8.03575361,20.0876892 C5.82661462,20.0876892 4.03575361,18.2968282 4.03575361,16.0876892 L4.03575361,12.031922 C4.03575361,8.1480343 6.79157254,4.90780265 10.4544842,4.15995321 C8.87553278,8.5612583 8.1226025,14.3600511 10.9452499,15.5413938 C13.710306,16.6986332 14.5947501,18.3118357 14.7118754,20.0876892 Z M14.2420017,23.8186831 C13.515543,27.1052019 12.7414284,30.2811559 18.0438552,31.7330419 L18.0438552,33.4450645 C18.0438552,35.6542035 16.2529942,37.4450645 14.0438552,37.4450645 L9.90612103,37.4450645 C6.14196811,37.4450645 3.09051926,34.3936157 3.09051926,30.6294627 L3.09051926,27.813861 C3.09051926,25.604722 4.88138026,23.813861 7.09051926,23.813861 L14.0438552,23.813861 C14.1102948,23.813861 14.1763561,23.8154808 14.2420017,23.8186831 Z M20.7553776,32.160536 C23.9336213,32.1190063 23.9061943,29.4103976 33.8698747,31.1666916 C34.7935223,31.3295026 35.9925894,31.0627305 37.3154077,30.4407183 C37.09778,34.8980343 33.4149547,38.4450645 28.9036761,38.4450645 C24.9909035,38.4450645 21.701346,35.7767637 20.7553776,32.160536 Z" fill="currentColor" opacity="0.1"></path>
                                    <g transform="translate(2.000000, 3.000000)">
                                        <path d="M8.5,1 C4.35786438,1 1,4.35786438 1,8.5 L1,13 C1,14.6568542 2.34314575,16 4,16 L13,16 C14.6568542,16 16,14.6568542 16,13 L16,4 C16,2.34314575 14.6568542,1 13,1 L8.5,1 Z" stroke="currentColor" strokeWidth="2"></path>
                                        <path d="M4,20 C2.34314575,20 1,21.3431458 1,23 L1,27.5 C1,31.6421356 4.35786438,35 8.5,35 L13,35 C14.6568542,35 16,33.6568542 16,32 L16,23 C16,21.3431458 14.6568542,20 13,20 L4,20 Z" stroke="currentColor" strokeWidth="2"></path>
                                        <path d="M23,1 C21.3431458,1 20,2.34314575 20,4 L20,13 C20,14.6568542 21.3431458,16 23,16 L32,16 C33.6568542,16 35,14.6568542 35,13 L35,8.5 C35,4.35786438 31.6421356,1 27.5,1 L23,1 Z" stroke="currentColor" strokeWidth="2"></path>
                                        <path d="M34.5825451,33.4769886 L38.3146092,33.4322291 C38.8602707,33.4256848 39.3079219,33.8627257 39.3144662,34.4083873 C39.3145136,34.4123369 39.3145372,34.4162868 39.3145372,34.4202367 L39.3145372,34.432158 C39.3145372,34.9797651 38.8740974,35.425519 38.3265296,35.4320861 L34.5944655,35.4768456 C34.048804,35.4833899 33.6011528,35.046349 33.5946085,34.5006874 C33.5945611,34.4967378 33.5945375,34.4927879 33.5945375,34.488838 L33.5945375,34.4769167 C33.5945375,33.9293096 34.0349773,33.4835557 34.5825451,33.4769886 Z" fill="currentColor" transform="translate(36.454537, 34.454537) rotate(-315.000000) translate(-36.454537, -34.454537) "></path>
                                        <circle stroke="currentColor" strokeWidth="2" cx="27.5" cy="27.5" r="7.5"></circle>
                                    </g>
                                </g>
                            </svg>
                            <span className="sr-only">Save your amazing power looks items and flip to cart now</span>

                            <span className="tab tab-whishlist block text-xs">Wishlist</span>
                        </a>

                    </div>
                </div>
            </div>
            <footer className=" relative 
             inset-x-0 bottom-0 bg-gray-900 rounded-lg shadow dark:bg-gray-900 m-2" role="contentinfo">
                <div className="w-full max-w-screen-xl mx-auto p-4 md:py-8">
                    <div className="sm:flex sm:items-center sm:justify-between">
                        <a href="#" className="flex items-center mb-4 sm:mb-0">
                            <img src={Logo} className="h-14 w-25 mr-3" alt="shoppp Logo" title="triokzz" />
                            <span className="sr-only">Save your amazing power looks items, Healthy products only on triokzz. flip to cart and get millets, dairy products, healthy snacks and more at one place -Triokzz, JiGari, Ted baker, fasion</span>
                        </a>
                    </div>
                    <div className="sm:flex sm:items-center sm:justify-between">
                        <a href="#" className="flex items-center mb-4 ml-4 sm:mb-0 text-white">
                            Products
                        </a>
                        <ul className="flex flex-wrap items-center mb-6 text-sm font-medium text-white sm:mb-0 dark:text-white">
                            <li className="mr-4 hover:underline md:mr-6 " onClick={() => navigate("/list/grocery/Organic-Grocery")}>
                                Grocery
                            </li>
                            <li className="mr-4 hover:underline md:mr-6 " onClick={() => navigate("/list/grocery/Healthy-Snacks")}>
                                Healty Snacks
                            </li>
                            <li className="mr-4 hover:underline md:mr-6 " onClick={() => navigate("/list/grocery/Millets")}>
                                Millets
                            </li>
                            <li className="mr-4 hover:underline md:mr-6" onClick={() => navigate("/list/grocery/Dairy-Products")}>
                                Dairy Products
                            </li>
                            <li className="mr-4 hover:underline md:mr-6 ">
                                <a href="/contact" className="hover:underline"><h2>Contact Us</h2></a>
                            </li>
                            <li className="mr-4 hover:underline md:mr-6 ">
                                <a href="/privacy" className="hover:underline"><h2>Return Policy</h2></a>
                            </li>
                        </ul>
                    </div>
                    <div className="sm:flex sm:items-center sm:justify-between">
                        <a href="#" className="flex items-center mb-4 ml-4 sm:mb-0 text-white">
                            Available Products
                        </a>
                        {
                            GroceryProducts && GroceryProducts.section.map((specialProd, i) => {
                                let [keys] = Object.keys(specialProd)
                                let arr = specialProd[keys]
                                // setProdkeys(arr)
                                // console.log(arr)
                                return (<ul key={i} className="flex flex-wrap items-center mb-6 text-sm font-medium text-white sm:mb-0 dark:text-white">
                                    {arr ? arr.map((val, id) => {
                                        let somthing = addtocard && addtocard.find((values) => {

                                            return values.id == val.id
                                        })
                                        if (!val.freez && somthing == undefined) {
                                            return (<li key={val.id} className="mr-4 hover:underline md:mr-6 ">
                                                <a href={`/organic-grocery/${main}/${val.type}${val.id}`} >{val.product_name} {val.color} {val.type}</a><br></br>
                                                <span className="sr-only">{val.product_detail}</span>
                                            </li>)
                                        }
                                    }) : ""
                                    }
                                </ul>)
                            }
                            )
                        }

                    </div>
                    <hr className="my-6 border-gray-200 sm:mx-auto dark:border-gray-700 lg:my-8" />

                    <div className="sm:flex sm:items-center sm:justify-between">
                        <span className="block text-sm text-white sm:text-center dark:text-gray-400">© 2023 Developed By <a href="https://www.triokzz.com/contact" className="hover:underline">Triokzz</a>. All Rights Reserved.</span>
                        <div className="flex mt-4 sm:justify-center sm:mt-0">
                            <a href="https://www.facebook.com/profile.php?id=61553460826080&mibexid=ZbWKwL" className="text-gray-500 hover:text-gray-900 dark:hover:text-white">
                                <svg className="w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 8 19">
                                    <path fillRule="evenodd" d="M6.135 3H8V0H6.135a4.147 4.147 0 0 0-4.142 4.142V6H0v3h2v9.938h3V9h2.021l.592-3H5V3.591A.6.6 0 0 1 5.592 3h.543Z" clipRule="evenodd" />
                                </svg>
                                <span className="sr-only">Experience the joy with Healthy  products every morning.</span>
                            </a>
                            <a href="https://www.instagram.com/triokzz?igsh=MWUzM3dweTNyY2NpeA==" className="text-gray-500 hover:text-gray-900 dark:hover:text-white ms-5">
                                <svg className="w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 21 16">
                                    <path d="M16.942 1.556a16.3 16.3 0 0 0-4.126-1.3 12.04 12.04 0 0 0-.529 1.1 15.175 15.175 0 0 0-4.573 0 11.585 11.585 0 0 0-.535-1.1 16.274 16.274 0 0 0-4.129 1.3A17.392 17.392 0 0 0 .182 13.218a15.785 15.785 0 0 0 4.963 2.521c.41-.564.773-1.16 1.084-1.785a10.63 10.63 0 0 1-1.706-.83c.143-.106.283-.217.418-.33a11.664 11.664 0 0 0 10.118 0c.137.113.277.224.418.33-.544.328-1.116.606-1.71.832a12.52 12.52 0 0 0 1.084 1.785 16.46 16.46 0 0 0 5.064-2.595 17.286 17.286 0 0 0-2.973-11.59ZM6.678 10.813a1.941 1.941 0 0 1-1.8-2.045 1.93 1.93 0 0 1 1.8-2.047 1.919 1.919 0 0 1 1.8 2.047 1.93 1.93 0 0 1-1.8 2.045Zm6.644 0a1.94 1.94 0 0 1-1.8-2.045 1.93 1.93 0 0 1 1.8-2.047 1.918 1.918 0 0 1 1.8 2.047 1.93 1.93 0 0 1-1.8 2.045Z" />
                                </svg>
                                <span className="sr-only">Follow Our Instagram Page And Get More exiting offers and coupan code.</span>
                            </a>
                            <a href="#" className="text-gray-500 hover:text-gray-900 dark:hover:text-white ms-5">
                                <svg className="w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 17">
                                    <path fillRule="evenodd" d="M20 1.892a8.178 8.178 0 0 1-2.355.635 4.074 4.074 0 0 0 1.8-2.235 8.344 8.344 0 0 1-2.605.98A4.13 4.13 0 0 0 13.85 0a4.068 4.068 0 0 0-4.1 4.038 4 4 0 0 0 .105.919A11.705 11.705 0 0 1 1.4.734a4.006 4.006 0 0 0 1.268 5.392 4.165 4.165 0 0 1-1.859-.5v.05A4.057 4.057 0 0 0 4.1 9.635a4.19 4.19 0 0 1-1.856.07 4.108 4.108 0 0 0 3.831 2.807A8.36 8.36 0 0 1 0 14.184 11.732 11.732 0 0 0 6.291 16 11.502 11.502 0 0 0 17.964 4.5c0-.177 0-.35-.012-.523A8.143 8.143 0 0 0 20 1.892Z" clipRule="evenodd" />
                                </svg>
                                <span className="sr-only">Twitter page</span>
                            </a>
                        </div>
                    </div>
                </div>
            </footer>
        </div >

    )
}

export default GroceryList;